/**
 * Logical ids, not rendered indices - tabs are flag gated, so a panel's index
 * depends on which flags are on. Defects.tsx maps between the two.
 */
export enum DefectTabs {
    summary,
    defects,
    gradingArea,
    recurringDefects,
    insights,
    pscRisk
}
